export default class PiliersModule {
    constructor(element) {
        this.$wrapper = element;

        this.items = this.$wrapper.querySelectorAll('.pilier');
        this.media = this.$wrapper.querySelector('.piliers__media img');
        this.figcaption = this.$wrapper.querySelector('.piliers__caption');

        if (!this.items.length) return;

        // Référence premier item
        this.firstItem = this.items[0];
        this.firstImage = this.firstItem.dataset.image || '';
        this.firstLegende = this.firstItem.dataset.legende || '';

        this.initFirstItem();
        this.bindEvents();
    }

    /* ------------------------------
       INIT
    ------------------------------ */

    initFirstItem() {
        this.firstItem.classList.add('is-active');

        const header = this.firstItem.querySelector('.pilier__header');
        const icon = this.firstItem.querySelector('.pilier__icon');

        if (icon && header) {
            icon.src = header.dataset.minus;
        }

        if (this.media) this.media.src = this.firstImage;
        if (this.figcaption) this.figcaption.textContent = this.firstLegende;
    }

    /* ------------------------------
       EVENTS
    ------------------------------ */

    bindEvents() {
        this.items.forEach(item => {
            const header = item.querySelector('.pilier__header');
            const icon = item.querySelector('.pilier__icon');

            if (!header) return;

            const plusIcon = header.dataset.plus;
            const minusIcon = header.dataset.minus;

            header.addEventListener('click', () => {
                const isActive = item.classList.contains('is-active');

                // Fermer tous les items
                this.items.forEach(i => {
                    i.classList.remove('is-active');
                    const ic = i.querySelector('.pilier__icon');
                    const h = i.querySelector('.pilier__header');
                    if (ic && h) ic.src = h.dataset.plus;
                });

                if (!isActive) {
                    // Ouvrir l’item
                    item.classList.add('is-active');
                    if (icon) icon.src = minusIcon;

                    // Sync image
                    if (this.media) this.media.src = item.dataset.image || '';
                    if (this.figcaption) {
                        this.figcaption.textContent = item.dataset.legende || '';
                    }
                } else {
                    // Tout fermé → reset image
                    if (this.media) this.media.src = this.firstImage;
                    if (this.figcaption) {
                        this.figcaption.textContent = this.firstLegende;
                    }
                }
            });
        });
    }
}
